import Image from "next/image"

import { Box } from "components/shared/box"

import styles from "./bot-with-rectangle.module.scss"

type BotWithRectangleProps = {
  imgSrc: string
  title: string
  text: string
}

export function BotWithRectangle({ imgSrc, title, text }: BotWithRectangleProps) {
  const rectangleClassNames =
    "absolute top-0 bottom-0 left-[0%] w-[75%] w-[min(60%)] sm:w-[min(45%,350px)] sm:left-[18%] rounded-2xl"
  const botClassNames =
    "w-[85%] h-[100%] pb-[50%] lg:w-[min(450px,70%)] sm:h-0 sm:pb-[min(450px,70%)] absolute bottom-0 -left-[5%] lg:left-[7%] pointer-events-none "

  return (
    <Box className="flex-1 relative pb-[min(700px,90%)] lg:pb-[min(500px,70%)] -mx-[5%]">
      <Box className={`${styles["rectangle"]} ${rectangleClassNames}`} />
      <Box className={`${rectangleClassNames}`} />
      <Box className={`${botClassNames}`}>
        <Image src={imgSrc} layout="fill" alt="bot" />
      </Box>
      <Box className="absolute pt-[14rem] lg:pt-[450px] ml-[1rem] lg:ml-[30%] w-[285px]">
        <Box className="font-bold text-[1.2rem] leading-[2rem] mb-2">{title}</Box>
        <Box className="text-4 leading-6">{text}</Box>
      </Box>
    </Box>
  )
}
